import { ErrorBoundary } from 'react-error-boundary'
import { AppProviders } from './providers'
import { AppRouter } from './router'
import { ErrorFallback } from '@/shared/components/ErrorFallback'

export function App() {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <AppProviders>
        <AppRouter />
      </AppProviders>
    </ErrorBoundary>
  )
}
